<template>
  <!-- a raiz herda o escopo do pai: o media query 770–1300px dele centraliza e espaça esta linha -->
  <div class="d-flex flex-wrap order-tabs justify-content-xl-start justify-content-center mb-xl-0 mb-3">
    <div
      v-for="tab in tabs"
      :key="tab.value"
      class="models-filters"
      :class="{ 'is-active': tab.value === active }"
      @click="emit('select', tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import modelsTradutor from "@/tradutors/models";

defineProps({
  active: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{ (e: "select", order: string): void }>();

const route = useRoute();
const translate = computed(() =>
  route.params.language === "pt-br"
    ? modelsTradutor.portugues
    : modelsTradutor.ingles
);

// valores de `order` aceitos pela API (Essay::scopeOrdemDaListagem no backend)
const tabs = computed(() => [
  { value: "order", label: translate.value.models },
  { value: "created_at", label: translate.value.lastModels },
  { value: "most_accessed", label: translate.value.mostViewed },
]);
</script>

<style scoped lang="css">
.order-tabs {
  row-gap: 6px;
}

.models-filters {
  font-family: "Bebas-Neue";
  font-size: 17px;
  font-weight: normal;
  padding: 0px 10px;
  border-left: 1px solid #666666;
  border-right: 1px solid #666666;
  cursor: pointer;
  /* em tela estreita a aba inteira desce de linha; o texto nunca quebra no meio */
  white-space: nowrap;
}

.models-filters.is-active {
  font-weight: bold;
}

/* 320–374px: folga para o negrito sintético (no Safari ele alarga o texto) */
@media screen and (max-width: 374px) {
  .models-filters {
    padding: 0px 6px;
  }
}
</style>
